import { DetailPage } from './DetailPage';

export {
    DetailPage
    }


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Logs/index.ts
 **/